export default "__VITE_ASSET__BrrSgjEO__"